// Bilingual content dictionary for SITMEC site (FR / EN)
// Restructured around the international purchasing hub as the leading service.

export const translations = {
    fr: {
        meta: {
            title: "SITMEC — Satisfaire vos exigences",
            tagline: "Satisfaire vos exigences",
        },
        nav: {
            home: "Accueil",
            purchasing: "Centrale d'achats",
            services: "Services",
            method: "Méthode",
            about: "À propos",
            cases: "Bénéfices",
            careers: "Carrières",
            contact: "Contact",
            cta: "Demander une offre",
        },
        hero: {
            kicker: "Centrale d'achats internationale · Maintenance industrielle",
            title1: "Satisfaire",
            title2: "vos exigences.",
            subtitle:
                "Centrale d'achats internationale et services techniques spécialisés. De la pièce détachée à la maintenance prédictive, nous accompagnons vos projets industriels de A à Z.",
            ctaPrimary: "Demander une offre",
            ctaSecondary: "Découvrir nos services",
            stats: [
                { value: "100+", label: "Marques partenaires dans le monde" },
                { value: "A → Z", label: "Accompagnement projets industriels" },
                { value: "24/7", label: "Maintenance & supervision" },
            ],
        },

        // ====== FEATURED: CENTRALE D'ACHATS ======
        purchasing: {
            kicker: "Service phare · Centrale d'achats internationale",
            title: "Sourcing mondial.",
            title2: "Livraison locale.",
            subtitle:
                "Un partenaire unique pour vos pièces de rechange, équipements et consommables industriels — quel que soit le secteur, quelle que soit la marque.",
            promiseTitle: "Notre promesse : une intervention SITMEC = des pièces disponibles ensuite.",
            promiseText:
                "Chaque mission technique réalisée par nos équipes (maintenance, alignement, vibratoire, GTB, électricité, climatisation) est sécurisée par notre centrale d'achats : nous garantissons l'approvisionnement des pièces de remplacement et consommables, en quelques jours, partout en Côte d'Ivoire et en sous-région.",
            marketsTitle: "Nos marchés prioritaires",
            markets: [
                {
                    n: "01",
                    title: "Énergie, Mine & Hydrocarbure",
                    text: "Pétrole, gaz, mines, énergies renouvelables — équipements certifiés et chaîne d'approvisionnement maîtrisée.",
                },
                {
                    n: "02",
                    title: "Négoce & fournitures",
                    text: "Approvisionnement multi-marques pour distributeurs et revendeurs industriels.",
                },
                {
                    n: "03",
                    title: "Services techniques spécialisés",
                    text: "Pièces et consommables pour bureaux d'études, intégrateurs et sociétés de maintenance.",
                },
                {
                    n: "04",
                    title: "Industrie manufacturière",
                    text: "Agroalimentaire, cimenterie, plasturgie, métallurgie — sourcing rapide et fiable.",
                },
            ],
            categoriesTitle: "Catégories produits",
            categories: [
                { title: "Matériels de manutention & convoyeurs", icon: "Truck" },
                { title: "Valves, pompes & robinetterie", icon: "GitBranch" },
                { title: "Équipements de laboratoire & consommables", icon: "FlaskConical" },
                { title: "Transmission, roulements, chaînes", icon: "Cog" },
                { title: "Énergie, électricité, automatisme", icon: "Zap" },
                { title: "Pièces détachées & outillage", icon: "Wrench" },
            ],
            ctaText: "Demander un devis",
        },

        // ====== TECHNICAL SERVICES ======
        services: {
            kicker: "Nos services techniques",
            title: "Trois pôles. Une expertise complète.",
            subtitle:
                "De la fiabilité des machines tournantes aux travaux d'électricité et climatisation, en passant par le bâtiment intelligent.",
            groups: [
                {
                    id: "reliability",
                    title: "Fiabilité & expertise machines",
                    items: [
                        {
                            id: "vibration",
                            icon: "Waves",
                            title: "Analyse vibratoire",
                            short:
                                "Diagnostic vibratoire pour détecter défauts mécaniques, balourd, désalignement et usure avant la panne.",
                            benefits: [
                                "Détection précoce",
                                "Maintenance ciblée",
                                "Rapport expert détaillé",
                            ],
                        },
                        {
                            id: "laser",
                            icon: "Crosshair",
                            title: "Alignement laser (lignage)",
                            short:
                                "Alignement haute précision des lignes d'arbres pour fiabilité et performance énergétique.",
                            benefits: [
                                "Mesure laser temps réel",
                                "Rapport avant / après",
                                "Réduction vibrations & usure",
                            ],
                        },
                        {
                            id: "predictive",
                            icon: "Activity",
                            title: "Maintenance prédictive & préventive",
                            short:
                                "Capteurs, surveillance conditionnelle et plans préventifs pour anticiper les défaillances et planifier les arrêts.",
                            benefits: [
                                "Surveillance 24/7",
                                "Plans préventifs sur mesure",
                                "Pièces de rechange sécurisées",
                            ],
                        },
                        {
                            id: "training",
                            icon: "GraduationCap",
                            title: "Formations techniques",
                            short:
                                "Programmes de formation certifiants en alignement laser, analyse vibratoire et maintenance préventive, animés avec nos partenaires leaders.",
                            benefits: [
                                "Sessions en présentiel",
                                "Cas pratiques terrain",
                                "Certification reconnue",
                            ],
                        },
                    ],
                },
                {
                    id: "building",
                    title: "Bâtiment intelligent & énergie",
                    items: [
                        {
                            id: "gtb",
                            icon: "Building2",
                            title: "GTB / GTC — Bâtiment intelligent",
                            short:
                                "Conception, intégration et retrofit de vos systèmes de gestion technique de bâtiment, neuf ou existant.",
                            benefits: [
                                "Remplacement d'automates obsolètes",
                                "Supervision centralisée",
                                "Calcul de ROI énergie",
                            ],
                        },
                        {
                            id: "led",
                            icon: "Lightbulb",
                            title: "Relamping LED & efficacité énergétique",
                            short:
                                "Audit lumière, étude DIALux, déploiement LED et intégration GTB pour réduire la facture.",
                            benefits: [
                                "60 à 80 % d'économie",
                                "Coût de maintenance réduit",
                                "Qualité lumineuse améliorée",
                            ],
                        },
                        {
                            id: "ev",
                            icon: "Plug",
                            title: "Bornes de recharge VE (AC & DC)",
                            short:
                                "De l'étude de faisabilité à la mise en service — entreprises, hôtels, centres commerciaux et collectivités.",
                            benefits: [
                                "Audit & dimensionnement",
                                "Installation & supervision",
                                "Contrôle d'accès et facturation",
                            ],
                        },
                    ],
                },
                {
                    id: "works",
                    title: "Travaux électricité & climatisation",
                    items: [
                        {
                            id: "electrical",
                            icon: "Zap",
                            title: "Travaux d'électricité industrielle & tertiaire",
                            short:
                                "Installation, mise aux normes et maintenance des installations électriques BT/HT pour vos sites industriels et tertiaires.",
                            benefits: [
                                "Tableaux & armoires électriques",
                                "Mise aux normes & conformité",
                                "Maintenance curative & préventive",
                            ],
                        },
                        {
                            id: "hvac",
                            icon: "Wind",
                            title: "Climatisation & CVC",
                            short:
                                "Étude, installation et maintenance de systèmes de climatisation, ventilation et chauffage — résidentiel, tertiaire et industriel.",
                            benefits: [
                                "Climatisation centralisée & split",
                                "Ventilation & traitement d'air",
                                "Contrat d'entretien sur mesure",
                            ],
                        },
                    ],
                },
            ],
        },

        method: {
            kicker: "Méthodologie",
            title: "Quatre étapes. Zéro improvisation.",
            subtitle:
                "Une approche structurée, du diagnostic terrain à la mise en service.",
            steps: [
                {
                    n: "01",
                    title: "Audit & visite terrain",
                    text: "Diagnostic complet de l'existant, mesure de la consommation et identification des points de friction.",
                },
                {
                    n: "02",
                    title: "Définition du besoin",
                    text: "Cadrage des objectifs techniques, énergétiques et budgétaires avec vos équipes.",
                },
                {
                    n: "03",
                    title: "Solution technique & commerciale",
                    text: "Étude détaillée (DIALux, dimensionnement, ROI), proposition transparente et chiffrée.",
                },
                {
                    n: "04",
                    title: "Installation & mise en œuvre",
                    text: "Travaux, mise en service, supervision, formation des équipes et fourniture des pièces de rechange.",
                },
            ],
        },

        benefits: {
            kicker: "Bénéfices mesurables",
            title: "Des résultats qui se voient sur la facture.",
            items: [
                {
                    value: "100+",
                    label: "Marques partenaires mondiales référencées",
                },
                {
                    value: "60-80%",
                    label: "Réduction de consommation après relamping LED",
                },
                {
                    value: "−40%",
                    label: "Arrêts non planifiés avec maintenance prédictive",
                },
                {
                    value: "A → Z",
                    label: "Accompagnement de vos projets industriels",
                },
            ],
        },

        sectors: {
            kicker: "Secteurs d'intervention",
            title: "Là où nos solutions font la différence.",
            items: [
                "Énergie, mine & hydrocarbure",
                "Industrie manufacturière",
                "Agroalimentaire & cimenterie",
                "Hôtels, resorts & tertiaire",
                "Centres commerciaux",
                "Collectivités & bâtiments publics",
                "Hôpitaux & cliniques",
                "Parkings & infrastructures",
            ],
        },

        catalog: {
            kicker: "Ressources",
            title: "Recevez notre catalogue Fiabilité & expertise machines.",
            subtitle:
                "Découvrez en détail nos prestations d'analyse vibratoire, alignement laser, maintenance prédictive et formations associées. Disponible en français et en anglais — envoi manuel par notre équipe sous 24 à 48 h ouvrées.",
            badge: "Catalogue PDF",
            highlights: [
                "Prestations & méthodologie détaillées",
                "Programmes de formation certifiants",
                "Cas d'usage industriels",
            ],
            cta: "Demander le catalogue",
            modalTitle: "Demander le catalogue",
            modalSubtitle:
                "Renseignez vos coordonnées et la version souhaitée. Notre équipe vous transmet le PDF par email sous 24 à 48 h ouvrées.",
            successTitle: "Demande bien reçue",
            successMsg:
                "Merci ! Nous avons bien reçu votre demande. Notre équipe vous enverra le catalogue par email dans les 24 à 48 h ouvrées.",
            successClose: "Fermer",
            cancel: "Annuler",
            submit: "Envoyer ma demande",
            submitting: "Envoi…",
            errorMsg: "Une erreur est survenue. Merci de réessayer.",
            requiredError: "Tous les champs marqués * sont obligatoires.",
            fields: {
                name: "Nom complet",
                company: "Société",
                email: "Email professionnel",
                phone: "Téléphone",
                language: "Version souhaitée",
                languageFr: "Français",
                languageEn: "Anglais",
                languageBoth: "Les deux versions",
            },
        },

        partners: {
            kicker: "Ils nous font confiance",
            title: "100+ marques mondiales référencées.",
            subtitle:
                "Pompes, valves, roulements, instrumentation, motorisation, automatisme — un sourcing multi-marques, sans dépendance fournisseur.",
            list: [
                "WIKA", "Victaulic", "Goodwin", "Armstrong", "Velan", "Pekos",
                "Fisher", "Flowserve", "Honeywell", "Endress+Hauser", "Flexitallic",
                "KLAW", "Leser", "Liquid Controls", "Müller", "Rotarex",
                "Schneider Electric", "ABB", "Legrand", "Bosch", "Bluetti",
                "Loctite", "JTEKT", "NSK", "SKF", "NTN", "Timken", "IKO",
                "Hutchinson", "IGOL", "Megadyne", "WD-40", "ContiTech",
                "Mercedes-Benz", "BMW", "Audi", "Porsche", "Land Rover",
                "Magni", "XCMG", "Perkins", "Cummins", "Doosan", "Hyundai",
                "Caterpillar", "IVECO", "Komatsu", "Volvo", "Renault", "Toyota",
            ],
        },

        about: {
            kicker: "À propos",
            title: "Une exigence d'ingénieurs, au service de votre performance.",
            paragraphs: [
                "SITMEC est une centrale d'achats internationale et un opérateur de services techniques industriels basé à Abidjan, Côte d'Ivoire.",
                "Nous accompagnons entreprises, industries et collectivités dans la maintenance, la modernisation et l'approvisionnement en pièces et équipements — du sourcing mondial à l'intervention terrain.",
                "Notre signature — « Satisfaire vos exigences » — n'est pas un slogan : c'est l'engagement d'une intervention rigoureuse, mesurable et durable, du diagnostic à l'après-vente.",
            ],
            mission: {
                title: "Notre mission",
                items: [
                    "Garantir la qualité, la fiabilité et la conformité des équipements et produits.",
                    "Répondre efficacement aux exigences techniques et réglementaires du secteur.",
                    "Fournir des solutions adaptées aux besoins spécifiques de nos clients.",
                    "Opérer dans le respect des dispositions légales en vigueur.",
                    "Accompagner nos clients dans leurs projets industriels de A à Z.",
                ],
            },
            values: [
                {
                    title: "Précision",
                    text: "Mesure, donnée, méthode. Aucune approximation.",
                },
                {
                    title: "Indépendance",
                    text: "Nos préconisations servent vos intérêts, pas un catalogue.",
                },
                {
                    title: "Partenariat mondial",
                    text: "Nos équipes sont formées en partenariat avec un leader mondial de la surveillance industrielle — et notre centrale d'achats nous permet d'élargir ce réseau à d'autres partenaires du même calibre selon vos besoins.",
                },
            ],
        },

        cases: {
            kicker: "Cas d'usage",
            title: "Ils nous ont fait confiance. Pourquoi pas vous ?",
            subtitle: "Aperçu anonymisé de projets représentatifs.",
            items: [
                {
                    sector: "Hôtellerie haut de gamme",
                    challenge: "Facture d'électricité élevée et plaintes clients sur l'éclairage.",
                    outcome: "Relamping LED + GTC : −68 % conso lumière, ROI < 24 mois.",
                },
                {
                    sector: "Industrie agroalimentaire",
                    challenge: "Arrêts répétés sur lignes de production critiques.",
                    outcome: "Analyse vibratoire + alignement laser + pièces de rechange en stock : 0 arrêt non planifié sur 9 mois.",
                },
                {
                    sector: "Centre commercial",
                    challenge: "Aucune visibilité sur les consommations multi-énergie.",
                    outcome: "Retrofit GTB + supervision centralisée : pilotage en temps réel.",
                },
                {
                    sector: "Mine & hydrocarbure",
                    challenge: "Approvisionnement critique de valves et roulements en urgence.",
                    outcome: "Centrale d'achats SITMEC : livraison sous 10 jours depuis 3 continents.",
                },
            ],
        },

        contact: {
            kicker: "Contact",
            title: "Parlons de votre projet.",
            subtitle:
                "Décrivez-nous votre besoin — pièces, intervention technique ou projet complet. Nous vous répondons sous 48 heures ouvrées.",
            fields: {
                name: "Nom complet",
                company: "Société",
                email: "Email professionnel",
                phone: "Téléphone (optionnel)",
                service: "Service concerné",
                serviceDefault: "Sélectionnez un service",
                message: "Votre message",
            },
            submit: "Envoyer la demande",
            submitting: "Envoi en cours…",
            successTitle: "Demande envoyée",
            successMsg:
                "Merci, nous avons bien reçu votre demande. Nous revenons vers vous très vite.",
            errorMsg: "Une erreur est survenue. Veuillez réessayer.",
            requiredError: "Merci de remplir les champs obligatoires.",
            info: {
                addressLabel: "Siège social",
                address: "Abidjan, Deux-Plateaux Agban — Côte d'Ivoire",
                emailLabel: "Email",
                emails: ["info@sitmec.com"],
                whatsappLabel: "WhatsApp",
                whatsappNumber: "+225 07 16 45 21 54",
                whatsappLink: "https://wa.me/2250716452154",
                whatsappCta: "Discuter sur WhatsApp",
                replyLabel: "Réponse sous",
                replyValue: "48 heures ouvrées",
            },
        },

        careers: {
            kicker: "Carrières",
            title: "Rejoignez nos équipes.",
            subtitle:
                "Nous recrutons des profils techniques passionnés. Découvrez nos offres en cours et postulez en quelques clics.",
            noJobs:
                "Aucune offre ouverte pour l'instant. Vous pouvez nous envoyer une candidature spontanée par email.",
            apply: "Postuler",
            spontaneous: "Candidature spontanée",
            deadline: "Date limite",
            location: "Localisation",
            department: "Département",
            type: "Contrat",
            modal: {
                title: "Postuler",
                subtitle: "Renseignez vos coordonnées et le lien vers votre CV.",
                fields: {
                    name: "Nom complet",
                    email: "Email",
                    phone: "Téléphone",
                    cv: "Lien vers votre CV (Google Drive, WeTransfer, LinkedIn…)",
                    message: "Lettre de motivation / message",
                },
                submit: "Envoyer ma candidature",
                submitting: "Envoi…",
                cancel: "Annuler",
                successTitle: "Candidature envoyée",
                successMsg:
                    "Merci pour votre intérêt. Notre équipe RH étudie votre candidature et vous répond rapidement.",
                close: "Fermer",
                requiredError: "Merci de remplir les champs obligatoires.",
                errorMsg: "Une erreur est survenue. Merci de réessayer.",
            },
        },

        footer: {
            tagline: "Satisfaire vos exigences.",
            rights: "Tous droits réservés.",
            legal: "RCCM CI-ABJ-03-2024-B12-09462",
            sections: {
                services: "Services",
                company: "Entreprise",
                contact: "Contact",
            },
        },
    },

    // ====== ENGLISH ======
    en: {
        meta: {
            title: "SITMEC — Meeting your demands",
            tagline: "Meeting your demands",
        },
        nav: {
            home: "Home",
            purchasing: "Purchasing hub",
            services: "Services",
            method: "Method",
            about: "About",
            cases: "Benefits",
            careers: "Careers",
            contact: "Contact",
            cta: "Request a quote",
        },
        hero: {
            kicker: "International purchasing hub · Industrial maintenance",
            title1: "Meeting",
            title2: "your demands.",
            subtitle:
                "International purchasing hub and specialized technical services. From spare parts to predictive maintenance, we support your industrial projects from A to Z.",
            ctaPrimary: "Request a quote",
            ctaSecondary: "Explore our services",
            stats: [
                { value: "100+", label: "Global brand partners" },
                { value: "A → Z", label: "End-to-end project support" },
                { value: "24/7", label: "Maintenance & supervision" },
            ],
        },
        purchasing: {
            kicker: "Flagship service · International purchasing hub",
            title: "Global sourcing.",
            title2: "Local delivery.",
            subtitle:
                "A single partner for your industrial spare parts, equipment and consumables — across every sector and brand.",
            promiseTitle: "Our promise: a SITMEC intervention = parts available afterward.",
            promiseText:
                "Every technical mission (maintenance, alignment, vibration, BMS, electrical, HVAC) is backed by our purchasing hub: we guarantee spare parts and consumables supply within days, anywhere in Ivory Coast and the sub-region.",
            marketsTitle: "Our priority markets",
            markets: [
                {
                    n: "01",
                    title: "Energy, Mining & Oil & Gas",
                    text: "Oil, gas, mining, renewables — certified equipment and mastered supply chain.",
                },
                {
                    n: "02",
                    title: "Trading & supplies",
                    text: "Multi-brand sourcing for industrial distributors and resellers.",
                },
                {
                    n: "03",
                    title: "Specialized technical services",
                    text: "Parts and consumables for engineering firms, integrators and maintenance companies.",
                },
                {
                    n: "04",
                    title: "Manufacturing industry",
                    text: "Food & beverage, cement, plastics, metallurgy — fast and reliable sourcing.",
                },
            ],
            categoriesTitle: "Product categories",
            categories: [
                { title: "Handling equipment & conveyors", icon: "Truck" },
                { title: "Valves, pumps & fittings", icon: "GitBranch" },
                { title: "Lab equipment & consumables", icon: "FlaskConical" },
                { title: "Transmission, bearings, chains", icon: "Cog" },
                { title: "Energy, electrical, automation", icon: "Zap" },
                { title: "Spare parts & tooling", icon: "Wrench" },
            ],
            ctaText: "Request a quote",
        },
        services: {
            kicker: "Our technical services",
            title: "Three pillars. One full-stack expertise.",
            subtitle:
                "From rotating machinery reliability to electrical and HVAC works, through smart buildings.",
            groups: [
                {
                    id: "reliability",
                    title: "Reliability & machine expertise",
                    items: [
                        {
                            id: "vibration",
                            icon: "Waves",
                            title: "Vibration analysis",
                            short:
                                "Vibration diagnostics to detect mechanical defects, unbalance, misalignment and wear before failure.",
                            benefits: ["Early detection", "Targeted maintenance", "Detailed expert report"],
                        },
                        {
                            id: "laser",
                            icon: "Crosshair",
                            title: "Laser alignment",
                            short:
                                "High-precision shaft alignment for reliability and energy performance.",
                            benefits: ["Real-time laser measurement", "Before / after report", "Less vibration & wear"],
                        },
                        {
                            id: "predictive",
                            icon: "Activity",
                            title: "Predictive & preventive maintenance",
                            short:
                                "Sensors, condition monitoring and preventive plans to anticipate failures and schedule shutdowns.",
                            benefits: ["24/7 monitoring", "Custom preventive plans", "Secured spare parts"],
                        },
                        {
                            id: "training",
                            icon: "GraduationCap",
                            title: "Technical training",
                            short:
                                "Certified training programs in laser alignment, vibration analysis and preventive maintenance, run with our world-class partners.",
                            benefits: ["In-person sessions", "Hands-on cases", "Recognized certification"],
                        },
                    ],
                },
                {
                    id: "building",
                    title: "Smart building & energy",
                    items: [
                        {
                            id: "gtb",
                            icon: "Building2",
                            title: "BMS / BAS — Smart building",
                            short:
                                "Design, integration and retrofit of building management systems, for new or existing assets.",
                            benefits: ["Replacing obsolete PLCs", "Centralized supervision", "Energy ROI modeling"],
                        },
                        {
                            id: "led",
                            icon: "Lightbulb",
                            title: "LED relamping & energy efficiency",
                            short:
                                "Lighting audit, DIALux study, LED rollout and BMS integration to cut your bill.",
                            benefits: ["60-80% savings", "Lower maintenance costs", "Better light quality"],
                        },
                        {
                            id: "ev",
                            icon: "Plug",
                            title: "EV charging stations (AC & DC)",
                            short:
                                "From feasibility study to commissioning — businesses, hotels, malls and public bodies.",
                            benefits: ["Audit & sizing", "Installation & supervision", "Access control and billing"],
                        },
                    ],
                },
                {
                    id: "works",
                    title: "Electrical & HVAC works",
                    items: [
                        {
                            id: "electrical",
                            icon: "Zap",
                            title: "Industrial & tertiary electrical works",
                            short:
                                "Installation, code compliance and maintenance of LV/HV electrical systems for industrial and tertiary sites.",
                            benefits: ["Switchboards & cabinets", "Code compliance", "Curative & preventive maintenance"],
                        },
                        {
                            id: "hvac",
                            icon: "Wind",
                            title: "HVAC & climate control",
                            short:
                                "Study, installation and maintenance of air conditioning, ventilation and heating — residential, tertiary and industrial.",
                            benefits: ["Central & split AC", "Ventilation & air treatment", "Tailored service contract"],
                        },
                    ],
                },
            ],
        },
        method: {
            kicker: "Methodology",
            title: "Four steps. Zero improvisation.",
            subtitle: "A structured approach, from on-site diagnosis to commissioning.",
            steps: [
                {
                    n: "01",
                    title: "Audit & site visit",
                    text: "Full diagnosis of existing setup, consumption measurement and pain-point mapping.",
                },
                {
                    n: "02",
                    title: "Needs definition",
                    text: "Scoping technical, energy and budget objectives with your team.",
                },
                {
                    n: "03",
                    title: "Technical & commercial proposal",
                    text: "Detailed study (DIALux, sizing, ROI), transparent costed proposal.",
                },
                {
                    n: "04",
                    title: "Installation & rollout",
                    text: "Works, commissioning, supervision, team training and spare parts supply.",
                },
            ],
        },
        benefits: {
            kicker: "Measurable benefits",
            title: "Results that show on your bill.",
            items: [
                { value: "100+", label: "Global brand partners referenced" },
                { value: "60-80%", label: "Consumption drop after LED relamping" },
                { value: "−40%", label: "Unplanned downtime with predictive maintenance" },
                { value: "A → Z", label: "Industrial project support" },
            ],
        },
        sectors: {
            kicker: "Sectors served",
            title: "Where our solutions make the difference.",
            items: [
                "Energy, mining & oil & gas",
                "Manufacturing industry",
                "Food & beverage and cement",
                "Hotels, resorts & tertiary",
                "Shopping malls",
                "Public bodies & buildings",
                "Hospitals & clinics",
                "Parkings & infrastructure",
            ],
        },

        catalog: {
            kicker: "Resources",
            title: "Request our Reliability & machine expertise catalog.",
            subtitle:
                "Discover in detail our vibration analysis, laser alignment, predictive maintenance and training services. Available in French and English — sent manually by our team within 24 to 48 business hours.",
            badge: "PDF catalog",
            highlights: [
                "Detailed services & methodology",
                "Certified training programs",
                "Industrial use cases",
            ],
            cta: "Request the catalog",
            modalTitle: "Request the catalog",
            modalSubtitle:
                "Share your details and pick the version you need. Our team will email you the PDF within 24 to 48 business hours.",
            successTitle: "Request received",
            successMsg:
                "Thank you! We received your request. Our team will email you the catalog within 24 to 48 business hours.",
            successClose: "Close",
            cancel: "Cancel",
            submit: "Send my request",
            submitting: "Sending…",
            errorMsg: "Something went wrong. Please try again.",
            requiredError: "Please fill in all required fields.",
            fields: {
                name: "Full name",
                company: "Company",
                email: "Work email",
                phone: "Phone",
                language: "Version requested",
                languageFr: "French",
                languageEn: "English",
                languageBoth: "Both versions",
            },
        },
        partners: {
            kicker: "They trust us",
            title: "100+ global brands referenced.",
            subtitle:
                "Pumps, valves, bearings, instrumentation, drives, automation — multi-brand sourcing with no vendor lock-in.",
            list: [
                "WIKA", "Victaulic", "Goodwin", "Armstrong", "Velan", "Pekos",
                "Fisher", "Flowserve", "Honeywell", "Endress+Hauser", "Flexitallic",
                "KLAW", "Leser", "Liquid Controls", "Müller", "Rotarex",
                "Schneider Electric", "ABB", "Legrand", "Bosch", "Bluetti",
                "Loctite", "JTEKT", "NSK", "SKF", "NTN", "Timken", "IKO",
                "Hutchinson", "IGOL", "Megadyne", "WD-40", "ContiTech",
                "Mercedes-Benz", "BMW", "Audi", "Porsche", "Land Rover",
                "Magni", "XCMG", "Perkins", "Cummins", "Doosan", "Hyundai",
                "Caterpillar", "IVECO", "Komatsu", "Volvo", "Renault", "Toyota",
            ],
        },
        about: {
            kicker: "About",
            title: "Engineering rigor at the service of your performance.",
            paragraphs: [
                "SITMEC is an international purchasing hub and an industrial technical services operator based in Abidjan, Ivory Coast.",
                "We support companies, industries and public bodies in maintenance, modernization and procurement of parts and equipment — from global sourcing to on-site work.",
                "Our signature — “Meeting your demands” — is not just a tagline. It is a commitment to rigorous, measurable, lasting intervention, from diagnosis to after-sales.",
            ],
            mission: {
                title: "Our mission",
                items: [
                    "Guarantee the quality, reliability and compliance of equipment and products.",
                    "Effectively meet the technical and regulatory requirements of the sector.",
                    "Deliver solutions tailored to our customers' specific needs.",
                    "Operate in full compliance with applicable regulations.",
                    "Support our customers on industrial projects from A to Z.",
                ],
            },
            values: [
                { title: "Precision", text: "Measure, data, method. No approximation." },
                {
                    title: "Independence",
                    text: "Our recommendations serve your interests, not a catalog.",
                },
                {
                    title: "Global partnership",
                    text: "Our teams are trained with a world leader in industrial monitoring — and our purchasing hub allows us to extend that network to other top-tier partners as your projects require.",
                },
            ],
        },
        cases: {
            kicker: "Use cases",
            title: "They trusted us. Why not you?",
            subtitle: "Anonymized snapshot of representative projects.",
            items: [
                {
                    sector: "Luxury hospitality",
                    challenge: "High electricity bills and guest complaints on lighting.",
                    outcome: "LED relamping + BMS: −68% lighting consumption, ROI < 24 months.",
                },
                {
                    sector: "Food & beverage industry",
                    challenge: "Repeated downtime on critical production lines.",
                    outcome: "Vibration analysis + laser alignment + spare parts on hand: zero unplanned downtime over 9 months.",
                },
                {
                    sector: "Shopping mall",
                    challenge: "No visibility on multi-energy consumption.",
                    outcome: "BMS retrofit + centralized supervision: real-time control.",
                },
                {
                    sector: "Mining & oil & gas",
                    challenge: "Critical valves and bearings needed urgently.",
                    outcome: "SITMEC purchasing hub: delivery within 10 days from 3 continents.",
                },
            ],
        },
        contact: {
            kicker: "Contact",
            title: "Let's talk about your project.",
            subtitle:
                "Tell us what you need — parts, technical intervention or full project. We get back to you within 48 working hours.",
            fields: {
                name: "Full name",
                company: "Company",
                email: "Work email",
                phone: "Phone (optional)",
                service: "Service of interest",
                serviceDefault: "Select a service",
                message: "Your message",
            },
            submit: "Send the request",
            submitting: "Sending…",
            successTitle: "Request sent",
            successMsg: "Thank you, we received your request and will get back to you soon.",
            errorMsg: "Something went wrong. Please try again.",
            requiredError: "Please fill in the required fields.",
            info: {
                addressLabel: "Head office",
                address: "Abidjan, Deux-Plateaux Agban — Ivory Coast",
                emailLabel: "Email",
                emails: ["info@sitmec.com"],
                whatsappLabel: "WhatsApp",
                whatsappNumber: "+225 07 16 45 21 54",
                whatsappLink: "https://wa.me/2250716452154",
                whatsappCta: "Chat on WhatsApp",
                replyLabel: "Reply within",
                replyValue: "48 working hours",
            },
        },
        careers: {
            kicker: "Careers",
            title: "Join our teams.",
            subtitle:
                "We hire passionate technical talent. Browse our current openings and apply in just a few clicks.",
            noJobs:
                "No open positions right now. You can still send us a spontaneous application by email.",
            apply: "Apply",
            spontaneous: "Spontaneous application",
            deadline: "Deadline",
            location: "Location",
            department: "Department",
            type: "Contract",
            modal: {
                title: "Apply",
                subtitle: "Share your details and a link to your resume.",
                fields: {
                    name: "Full name",
                    email: "Email",
                    phone: "Phone",
                    cv: "Resume link (Google Drive, WeTransfer, LinkedIn…)",
                    message: "Cover letter / message",
                },
                submit: "Send my application",
                submitting: "Sending…",
                cancel: "Cancel",
                successTitle: "Application sent",
                successMsg:
                    "Thank you for your interest. Our HR team is reviewing your application and will get back to you shortly.",
                close: "Close",
                requiredError: "Please fill in the required fields.",
                errorMsg: "Something went wrong. Please try again.",
            },
        },
        footer: {
            tagline: "Meeting your demands.",
            rights: "All rights reserved.",
            legal: "RCCM CI-ABJ-03-2024-B12-09462",
            sections: {
                services: "Services",
                company: "Company",
                contact: "Contact",
            },
        },
    },
};
